import { useCallback } from 'react'
import {
  getCommunicationCenterPerformanceReport,
  type CommunicationCenterPerformanceReportResult,
  type ReportBucketType,
} from '@services/api/reports/engagement.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type CommunicationCenterPerformanceData =
  CommunicationCenterPerformanceReportResult

export type UseCommunicationCenterPerformanceResult = {
  loading: boolean
  error: string | null
  data: CommunicationCenterPerformanceData | null
  bucketLabel: string
}

export function useCommunicationCenterPerformance(
  toolbarSelection: Record<string, string>,
): UseCommunicationCenterPerformanceResult {
  const getBucketFromData = useCallback(
    (data: CommunicationCenterPerformanceReportResult): ReportBucketType =>
      data.callVolumeOutcomes.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getCommunicationCenterPerformanceReport,
    getBucketFromData,
    errorMessage: 'Failed to load communication center performance data',
  })
}
